import { Component, Input } from '@angular/core';

import { getKeysFromObjects } from 'rev-shared/util';

import { VbUiBarChartComponent, VB_UI_BAR_CHART_TEMPLATE, VB_UI_BAR_CHART_HOST_CLASS } from '../VbUiBarChart.Component';

import styles from '../VbUiBarChart.Component.module.less';

@Component({
	selector: 'vb-ui-stacked-bar-chart',
	host: {
		'[class]': VB_UI_BAR_CHART_HOST_CLASS
	},
	template: VB_UI_BAR_CHART_TEMPLATE,
	standalone: false
})
export class VbUiStackedBarChartComponent extends VbUiBarChartComponent {
	@Input() public tooltipGenerateFunc: (dataContext, seriesName, seriesValue) => string;

	protected initChartConfig(): void {
		super.initChartConfig();

		this.chartConfig = Object.assign(this.chartConfig, {
			cursor: {
				disabled: true,
				type: 'XYCursor'
			},
			series: this.getColumnSeries(),
			paddingRight: 30
		});
	}

	protected getColumnSeries(): any[] {
		return getKeysFromObjects(this.data)
			.map(key => key !== this.categoryField && !key.includes('@') && this.createSeries(key))
			.filter(Boolean);
	}

	// Create series
	private createSeries(field: string): any {
		const categoryDataField: string = this.getCategoryDataField();
		const valueDataField: string = this.getValueDataField();
		const tooltipGenerateFunc = this.tooltipGenerateFunc;

		return {
			type: 'ColumnSeries',
			name: field,
			columns: {
				tabindex: -1,
				events: {
					hit: event => this.onBarHitInternal(event)
				},
				tooltipText: this.tooltipText ||
					`[bold]{name}[/]\n{${categoryDataField}}: {${valueDataField}}`,
				adapter: {
					tooltipText: function(text, target, key) {
						if (!tooltipGenerateFunc) {
							return text;
						}
						const { dataContext } = target.dataItem;
						return tooltipGenerateFunc(dataContext, field, `{${valueDataField}}`);
					}
				}
			},
			dataFields: {
				[categoryDataField]: this.categoryField,
				[valueDataField]: field
			},
			sequencedInterpolation: true,
			stacked: true
		};
	}

}
